import { useState, useEffect } from 'react';
import { campaigns } from '../api/client.js';
import { useAuth } from '../auth/AuthContext.jsx';

const STATUS_OPTIONS = [
  { value: '', label: 'Tous les statuts' },
  { value: 'pending', label: 'En attente' },
  { value: 'scheduled', label: 'Planifié' },
  { value: 'delivered', label: 'Livré' },
  { value: 'failed', label: 'Échoué' },
];

/**
 * Filter controls for export: date range, status, driver.
 * @param {{ filters: object, onChange: (filters: object) => void }} props
 */
export default function ExportFilters({ filters, onChange }) {
  const { activeCampaign } = useAuth();
  const [drivers, setDrivers] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!activeCampaign) return;
    campaigns.listUsers(activeCampaign)
      .then((users) => setDrivers(users.filter((u) => u.role === 'driver' || u.role === 'coordinator')))
      .catch(() => {/* ignore */});
  }, [activeCampaign]);

  const update = (key, value) => {
    const next = { ...filters };
    if (value) {
      next[key] = value;
    } else {
      delete next[key];
    }
    onChange(next);
  };

  return (
    <div>
      <button
        onClick={() => setExpanded(!expanded)}
        className="text-sm text-blue-600 underline mb-2"
      >
        {expanded ? 'Masquer les filtres' : 'Filtrer les exports'}
      </button>

      {expanded && (
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>
            <label className="block text-xs text-gray-500 mb-1">Date début</label>
            <input
              type="date"
              value={filters.dateFrom || ''}
              onChange={(e) => update('dateFrom', e.target.value)}
              className="w-full px-2 py-1.5 border rounded text-sm"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Date fin</label>
            <input
              type="date"
              value={filters.dateTo || ''}
              onChange={(e) => update('dateTo', e.target.value)}
              className="w-full px-2 py-1.5 border rounded text-sm"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Statut</label>
            <select
              value={filters.status || ''}
              onChange={(e) => update('status', e.target.value)}
              className="w-full px-2 py-1.5 border rounded text-sm"
            >
              {STATUS_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Livreur</label>
            <select
              value={filters.driverId || ''}
              onChange={(e) => update('driverId', e.target.value)}
              className="w-full px-2 py-1.5 border rounded text-sm"
            >
              <option value="">Tous les livreurs</option>
              {drivers.map((d) => (
                <option key={d.id} value={d.id}>{d.name}</option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}
